import { isEqual } from "lodash-es";
import { RootState } from "configs/store/types";
import useParams from "./useParams";
import useSelector from "./useSelector";

const useCurrentCase = <TReturn>(
  callback: (currentCase: RootState["cases"][number]) => TReturn
): TReturn => {
  const { id: caseId } = useParams();
  return useSelector(({ cases }) => callback(cases[caseId]), isEqual);
};

export default useCurrentCase;
